import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as libraryActions from '~/library/actions';
import Helpers from '~/utils/Helpers';
import { Link } from 'react-router';
import { Table, Thead, Th, Tr, Td } from 'SourceClear-Reactable';
import CvssService from '~/utils/CvssService';
type LibraryViewReleasesProps = {
  libraryState: object;
  actions: object;
  myState: object;
  orgState: object;
};
class LibraryViewReleases extends React.Component<LibraryViewReleasesProps, {}> {
  updateFilter = e => {
    let filter = e.target.value;
    this.props.actions.updateVersionFilter(filter.toLowerCase());
  };
  getFilteredVersions() {
    const { libraryState } = this.props;
    const { versionFilter = '' } = libraryState;
    const { component = {} } = libraryState;
    const { libraryModel = {} } = component;
    const { versions = [] } = libraryModel;
    if (!versionFilter) {
      return versions;
    }
    return versions.filter(fullVersion => {
      let { version = '' } = fullVersion;
      return _.startsWith(version.toLowerCase(), versionFilter);
    });
  }
  render() {
    const { libraryState } = this.props;
    const { versionFilter = '', url = '', cvss } = libraryState;
    const isCvss3Selected = cvss === 'cvss3' && CvssService.isCvss3Enabled();
    let versionElements = [],
      filteredVersions = this.getFilteredVersions();
    filteredVersions.forEach(version => {
      const {
        vulnCounts = {},
        cvss2VulnCounts = {},
        cvss3VulnCounts = {},
        version: displayVersion,
        releaseDate,
      } = version;
      const formattedReleaseDate = Helpers.formatDate(releaseDate);
      let countsElement;
      const vulnCountsObj = isCvss3Selected
        ? cvss3VulnCounts
        : !_.isEmpty(cvss2VulnCounts)
        ? cvss2VulnCounts
        : vulnCounts;
      const {
        critical: criticalCount,
        high: highCount,
        medium: mediumCount,
        low: lowCount,
      } = vulnCountsObj;
      const versionUrl = `${url}/versions/${displayVersion}`;
      countsElement = (
        <div className="grid">
          <div className="grid__item col-1-1 color--white">
            <div
              className={
                'inline-block bg-color--warning-light ph- pv-- ' +
                (lowCount === 0 ? 'opacity--4-10' : '')
              }
            >
              {lowCount}
            </div>
            <div
              className={
                'inline-block bg-color--warning ph- pv-- ml-- ' +
                (mediumCount === 0 ? 'opacity--4-10' : '')
              }
            >
              {mediumCount}
            </div>
            <div
              className={
                'inline-block bg-color--danger ph- pv-- ml-- ' +
                (highCount === 0 ? 'opacity--4-10' : '')
              }
            >
              {highCount}
            </div>
            {isCvss3Selected && (
              <div
                className={
                  'inline-block bg-color--danger-dark ph- pv-- ml-- ' +
                  (criticalCount === 0 ? 'opacity--4-10' : '')
                }
              >
                {criticalCount}
              </div>
            )}
          </div>
        </div>
      );
      versionElements.push(
        <Tr key={`${version}`}>
          <Td column="version">
            <Link to={versionUrl} className="link--primary">
              {displayVersion}
            </Link>
          </Td>
          <Td column="release-date">{formattedReleaseDate || 'n/a'}</Td>
          <Td column="vulnerabilities">{countsElement}</Td>
        </Tr>
      );
    });
    const table = (
      <Table
        className="reactable-table reactable-release-history min-height--205"
        id="reactable-release-history"
        itemsPerPage={4}
        pageButtonLimit={10}
        hideFilterInput
        noDataText="No releases found."
      >
        <Thead>
          <Th column="version" className="col-1-3">
            <strong>Version</strong>
          </Th>
          <Th column="release-date" className="col-1-3">
            <strong>Release Date</strong>
          </Th>
          <Th column="vulnerabilities" className="col-1-3">
            <strong>Vulnerabilities</strong>
          </Th>
        </Thead>
        {versionElements}
      </Table>
    );
    return (
      <div className="grid pb+">
        <div className="grid__item col-1-1">
          <input
            name="versions"
            className="col-1-3 phone--col-1-1"
            type="text"
            placeholder="Filter by version number"
            defaultValue={versionFilter}
            onChange={this.updateFilter}
          />
        </div>
        <div className="grid__item col-1-1 mt">{table}</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
    myState: state.myState,
    orgState: state.orgState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(libraryActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryViewReleases);
